
import {
    Component,  TemplateRef, ContentChild, EventEmitter, Output, ElementRef, Renderer2, AfterViewInit, OnInit, Input, HostListener, OnChanges, SimpleChanges, Host, Optional
} from '@angular/core';
import { Observable, fromEvent, Subscription } from 'rxjs';
import * as _ from 'underscore';
import { FocusNextDirective } from '@otas/utils/directives/helper/focus-next.directive';
import { debounceTime } from 'rxjs/operators';
import { EnterKeyListenerDirective } from '@otas/utils/directives/helper/enter.directive';
declare let $: any;

@Component({
    selector: 'app-vendor-name-panel',
    template: `
    <div [style.display]="visible ? 'block' : 'none'" >
    <div class="dropdown-container">
    <ul class="dropdown-menu" style="width: 100%;">
    <li  *ngFor="let vendor of vendors;trackBy: trackByFn;let i=index;" (click)="setvalue(vendor)" id="{{vendor?.id}}" (mouseenter)="mouseOver($event)" (mouseleave)="mouseLeave($event)"  role="menuitem">
    <div class="drop-down-row" >
    <a  href="javascript:void(0)"  tabindex="-1" class="dropdown-item">
    <div>

    {{vendor?.prefix}} {{vendor.name}} {{vendor?.suffix}}</div>
    </a>
  </div>
   
   </li>
   
    </ul>
    <ng-container *ngIf="!!settings">
    <ng-container  *ngTemplateOutlet="settings"></ng-container>
    </ng-container>
   </div>
   </div>
`,
    styleUrls: ['./vendorNameAutoSuggestionPanel.css'],
    providers: [
        FocusNextDirective
    ],
    standalone: false
})
export class VendorNameAutoSuggestionPanelComponent implements OnInit, AfterViewInit {
    @Input() vendors: any = [];
    vendorList: any = [];
    @Output() settingVendorName = new EventEmitter();
    @ContentChild(TemplateRef, { read: TemplateRef, static: false }) settings;
    visible = false;
    @Input() suggestion = false;
    blurSubscription: Subscription;
    blurObservable: Observable<any>;
    constructor(private elementRef: ElementRef,
        @Optional() @Host() private enterKeyDirective: EnterKeyListenerDirective,
        private renderer: Renderer2, private focusnxt: FocusNextDirective) { }

    setvalue(vendor) {
        // console.log(vendor);
        this.settingVendorName.emit(vendor);
        const parent = (this.enterKeyDirective as any).el.nativeElement;
        this.focusnxt.selectClick(parent, this.elementRef);
        this.hide();
    }
    trackByFn(index, item) {
        return index; // or item.id
    }
    ngAfterViewInit() {
        setTimeout(() => {
            const parent = this.renderer.parentNode(this.elementRef.nativeElement);
            const childInput = parent.children[0].querySelector('input');

            this.renderer.listen(childInput, 'keydown', (event) => {
                this.keydown(event);
            });
            this.inputFieldBlurListener();

        }, 50);
    }
    inputFieldBlurListener() {
        const parent = this.renderer.parentNode(this.elementRef.nativeElement);
        const childInput = parent.children[0].querySelector('input');

        this.blurObservable = fromEvent(childInput, 'blur').pipe(debounceTime(200));
        this.blurSubscription = this.blurObservable.subscribe((event: any) => {
            const listDevotee: NodeList = this.elementRef.nativeElement.querySelectorAll('ul.dropdown-menu li');

            let liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');
            setTimeout(() => {

                if (document.activeElement !== childInput) {
                    if (!!childInput.value) {
                        let obj = _.find(this.vendors, vendor => vendor[vendor.prefix ? 'prefix' : 'name'] === (childInput.value));
                        if (!obj) {
                            obj = _.find(this.vendors, vendor => vendor.name.includes(childInput.value));
                        }
                        if (!this.suggestion) {
                            obj = _.find(this.vendors, vendor => vendor[vendor.prefix ? 'prefix' : 'name'] === (childInput.value));
                        } else {

                            obj = _.find(this.vendors, vendor => vendor[vendor.prefix ? 'prefix' : 'name'].includes(childInput.value)) || _.find(this.vendors, vendor => vendor.name.includes(childInput.value));
                        }
                        if (!!liSelected) {
                            const id = +liSelected.getAttribute('id');
                            obj = _.find(this.vendors, vendor => id === vendor.id);
                            const returnValue = obj ? obj : { name: childInput.value };
                            // console.log('liSelected', returnValue);
                        }
                        const returnValue = obj ? obj : { name: childInput.value };
                        // console.log('childInput.value', returnValue, childInput.value);
                        this.settingVendorName.emit(returnValue);
                    }
                    else if (!!liSelected) {
                        const id = +liSelected.getAttribute('id');
                        const obj = _.find(this.vendors, vendor => id === vendor.id);
                        const returnValue = obj ? obj : { name: childInput.value };
                        // console.log('liSelected', returnValue);
                        this.settingVendorName.emit(returnValue);
                    }
                    else {
                        // console.log('else');
                        this.settingVendorName.emit(this.suggestion ? null : { name: childInput.value });
                    }
                }
            }, 50);

        });
    }
    focusFirstElement(e) {
        const listDevotee: any[] = this.elementRef.nativeElement.querySelectorAll('ul.dropdown-menu li');
        let liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');

        if (this.vendorList.length) {
            if ([40, 38, 13].indexOf(e.keyCode) === -1) {
                if (!liSelected) {
                    this.renderer.addClass(listDevotee[0], 'selected');
                } else {

                    this.renderer.removeClass(liSelected, 'selected');
                    this.renderer.addClass(listDevotee[0], 'selected');

                }
            }
            liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');
            if (liSelected) {
                liSelected.scrollIntoView(true);
            }
        }
    }
    mouseOver(event: Event) {
        const li = (event.target as HTMLElement).closest('ul.dropdown-menu li');
        if (!li) { return; }
        const liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');
        if (liSelected) {
          this.renderer.removeClass(liSelected, 'selected');
        }
        this.renderer.addClass(li, 'selected');
      }
      
      mouseLeave(event: Event) {
        const liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');
        if (liSelected) {
          this.renderer.removeClass(liSelected, 'selected');
        }
      }      
    keydown(e: KeyboardEvent) {

        const listDevotee: NodeList = this.elementRef.nativeElement.querySelectorAll('ul.dropdown-menu li');
        let liSelected = this.elementRef.nativeElement.querySelector('ul.dropdown-menu li.selected');
        const renderer = this.renderer;
        if (this.suggestion) {
            this.focusFirstElement(e);
        }
        let next;


        switch (e.keyCode) {

            case 40:
                e.preventDefault();
                if (!!listDevotee.length) {
                    if (liSelected) {
                        // console.log(liSelected.getAttribute('id'), 'attribute');

                        listDevotee.forEach((li, i) => {
                            if (li === liSelected) {
                                renderer.removeClass(liSelected, 'selected');
                                const index = i < listDevotee.length - 1 ? i + 1 : 0;
                                next = listDevotee[index];

                                renderer.addClass(next, 'selected');
                                next.scrollIntoView(false);
                                return;
                            }
                        });
                    } else {
                        renderer.addClass(listDevotee[0], 'selected');
                    }
                }
                break;

            case 38:
                e.preventDefault();
                if (liSelected) {
                    listDevotee.forEach((li, i) => {

                        if (li === liSelected) {
                            renderer.removeClass(liSelected, 'selected');
                            const index = i > 0 ? i - 1 : listDevotee.length - 1;
                            next = listDevotee[index];
                            renderer.addClass(next, 'selected');
                            next.scrollIntoView(false);
                            // console.log(next);

                            return;
                        }
                    });
                } else {
                    renderer.addClass(listDevotee[listDevotee.length - 1], 'selected');
                }
                break;
            case 13: {
                e.preventDefault();
                if (!!liSelected) {
                    let index;
                    listDevotee.forEach((li, i) => {
                        if (li === liSelected) {
                            index = i;
                            return;
                        }
                    });
                    const obj = this.vendors[index];
                    this.settingVendorName.emit(obj);
                    this.blurSubscription.unsubscribe();
                    setTimeout(() => {
                        this.inputFieldBlurListener();
                    }, 500);
                }
                if (this.enterKeyDirective) {
                    e.preventDefault();
                    const parent = (this.enterKeyDirective as any).el.nativeElement;
                    this.focusnxt.selectClick(parent, this.elementRef);

                }
            }
                this.hide();
                break;

        }

    }
    ngOnInit() {
    }
    show() {
        this.visible = true;
        setTimeout(() => {
            const f = this.elementRef.nativeElement.querySelector('.dropdown-menu');
            this.renderer.addClass(f, 'show');
            this.renderer.removeAttribute(f, 'style');
            this.renderer.setStyle(f, 'width', ' 100%');
            this.renderer.setStyle(f, 'overflow-y', 'scroll');
            this.renderer.setStyle(f, 'max-height', '250px');
        }, 0);


    }
    changeList(data) {
        if (!!data) {

            this.vendors = data;
        }
    }

    hide() {

        this.visible = false;
        this.elementRef.nativeElement.querySelectorAll('ul.dropdown-menu li').forEach(e => {
            if (e) {
                this.renderer.removeClass(e, 'selected');

            }
        });
    }

}